export const LEGAL_DOCUMENT_VERSION = '2026-10-12.1';
export const PRIVACY_POLICY_PATH = '/pages/politika-konfidentsialnosti-personalnykh-dannykh/';
export const PERSONAL_DATA_CONSENT_PATH = '/pages/soglasie-na-obrabotku-personalnykh-dannykh/';
export const MARKETING_CONSENT_PATH = '/pages/soglasie-na-reklamnuyu-rassylku/';
